/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUserActionSkipped
 */
export interface BulkUserActionSkipped {
    /**
     * 
     * @type {string}
     * @memberof BulkUserActionSkipped
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BulkUserActionSkipped
     */
    reason: string;
}

/**
 * Check if a given object implements the BulkUserActionSkipped interface.
 */
export function instanceOfBulkUserActionSkipped(value: object): value is BulkUserActionSkipped {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function BulkUserActionSkippedFromJSON(json: any): BulkUserActionSkipped {
    return BulkUserActionSkippedFromJSONTyped(json, false);
}

export function BulkUserActionSkippedFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserActionSkipped {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reason': json['reason'],
    };
}

export function BulkUserActionSkippedToJSON(json: any): BulkUserActionSkipped {
    return BulkUserActionSkippedToJSONTyped(json, false);
}

export function BulkUserActionSkippedToJSONTyped(value?: BulkUserActionSkipped | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reason': value['reason'],
    };
}

